import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AdminPanel from '../../components/Admin/AdminPanel';
import { MOBILE_APP_BACK_LABEL, MOBILE_APP_NAME } from './appBranding';
import './mobile.css';

/**
 * Full desktop Admin Panel inside LGL Portal (`/m/admin`).
 * Superintendents never see this — only canAccessAdminPanel users get the entry
 * on live `/m`. Preview (`/m/preview/admin`) is for design/QA without Azure.
 * Wider than the phone walk UI so tables/tabs stay usable on tablet/desktop-in-APK.
 */
export const MobileAdminScreen = ({ user = null }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const backPath = location.pathname.startsWith('/m/preview') ? '/m/preview' : '/m';

  useEffect(() => {
    const prevTitle = document.title;
    document.title = `Admin · ${MOBILE_APP_NAME}`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <div className="lgl-m-admin-shell" data-testid="field-admin-shell">
      <header className="lgl-m-admin-bar" role="navigation" aria-label={MOBILE_APP_BACK_LABEL}>
        <button
          type="button"
          className="lgl-m-admin-back"
          onClick={() => navigate(backPath)}
        >
          ← {MOBILE_APP_BACK_LABEL}
        </button>
        <span className="lgl-m-admin-bar-note">
          Same Admin Panel as the website — stays in this app.
        </span>
      </header>
      <div className="lgl-m-admin-body">
        <AdminPanel onClose={() => navigate(backPath)} user={user} />
      </div>
    </div>
  );
};

export default MobileAdminScreen;
